'use client';

import { PageProps, PollQuestion } from '@/lib/types';
import { Breadcrumb, Empty, Section } from '@/ui';
import { Content, Poll } from '@/widgets';
import { Container, Divider, Flex } from '@mantine/core';
import React from 'react';

type Props = {
  pollData: PageProps & {
    title: string;
    data: {
      question: PollQuestion;
    }[];
  };
};

export default function Polls({ pollData }: Props) {
  const breadcrumbItems = [
    { title: pollData?.breadcrumb, href: `/general-menu/${pollData?.menu_id}` },
    { title: pollData?.title, isCurrent: true },
  ];

  return (
    <Container>
      <Section
        rightMenu={{
          isActive: true,
          id: pollData?.menu_id,
          activeItem: { id: pollData?.menu_item_id },
        }}
      >
        <Content>
          <Content.Header>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{pollData?.title}</Content.Title>
          <Content.Body>
            {pollData?.data?.length > 0 ? (
              <Flex direction="column" gap="lg">
                {pollData?.data?.map((vote, index) => (
                  <React.Fragment key={vote?.question?.id}>
                    <Poll question={vote?.question} />
                    {index < pollData?.data?.length - 1 && <Divider my="lg" />}
                  </React.Fragment>
                ))}
              </Flex>
            ) : (
              <Empty />
            )}
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
